import Container from "@components/Container/Container";
import { videoFields } from "@ee/utils/constants";
import YouTubeVideo from "@routes/Article/components/StoryElements/YouTubeVideo";

/**
 * Component to render Recognition Section of EE on homepage
 */
const EERecognitionSection = (): React.ReactElement => {
  return (
    <Container
      rootClassName="px-5"
      data-testid="ee-recognition-section-component"
    >
      <h2 className="mb-1 text-left font-public-sans text-4xl font-semibold leading-10 text-gray-850 md:text-6xl lg:text-8xl">
        {"Gain recognition for your business "}
      </h2>

      <p className="mb-4 text-left font-public-sans text-gray-550">
        {"Join Asia's leading business awards for SMEs and start-ups"}
      </p>

      <div className="mb-6 flex w-full flex-col items-stretch justify-center text-center text-gray-850 lg:flex-row">
        <div className="mr-8 w-full lg:w-6/12">
          <YouTubeVideo
            key={"test"}
            fields={videoFields}
            iframeClassName="h-[330px] lg:h-[370px]"
          />
        </div>

        <div className="mt-4 w-full text-left font-public-sans leading-6 lg:mt-0 lg:w-6/12 lg:pl-3">
          <p>
            <strong>
              Fostering and building a sustainable entrepreneurial ecosystem
            </strong>
          </p>

          <p className="text-md pl-0">
            We invite your business to shine at the Emerging Enterprise Award
            and Emerging Enterprise Sustainability Award. Established in 2008,
            these awards empowers startups and young businesses under 10 years
            old across Singapore and Asia.
          </p>

          <p>
            The Emerging Enterprise Award and Emerging Enterprise Sustainability
            Award, co-presented by OCBC and The Business Times, celebrates
            dynamic and forward-thinking enterprises poised for growth and
            innovation. Finalists and winners gain access to invaluable
            resources, enabling them to unlock their full potential.
          </p>

          <p>
            Whether through growth or innovation, the Emerging Enterprise Award
            and the Emerging Enterprise Sustainability Award are your
            opportunities to stand out.
          </p>

          <p>
            Don’t miss the chance to highlight your company’s growth and
            innovation. Join the ranks of exceptional businesses striving for
            these coveted awards. Apply now to gain the recognition your
            business deserves!
          </p>
        </div>
      </div>
    </Container>
  );
};

export default EERecognitionSection;
